import { create } from "zustand";
import axios from "../lib/axios.js";

export const useUserStore = create((set, get) => ({
  user: null,
  checkingAuth: true,

  signup: async (email, password, name, role) => {
    try {
      const res = await axios.post("/auth/signup", {
        email,
        password,
        name,
        role,
      });
      console.log("Signup successful:", res.data);
    } catch (error) {
      console.error("Signup failed:", error.response?.data || error.message);
      throw error;
    }
  },

  login: async (email, password) => {
    try {
      const res = await axios.post("/auth/login", { email, password });
      set({ user: res.data.user });
      console.log("Login successful:", res.data);
    } catch (error) {
      console.error("Login failed:", error.response?.data || error.message);
      throw error;
    }
  },

  logout: async () => {
    try {
      await axios.post("/auth/logout");
      set({ user: null }); // Clear user state
    } catch (error) {
      console.error("Logout failed:", error.response?.data || error.message);
      throw error;
    }
  },

  getUser: async (role = null) => {
    try {
      const queryParam = role ? `?role=${role}` : ""; // Add role as a query parameter if provided
      const response = await axios.get(`/auth/users${queryParam}`); // Call the backend API
      set({ user: response.data }); // Store the fetched users in the store
    } catch (error) {
      console.error(
        "Failed to fetch users:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
}));
